import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import ActivityAmount from 'apps/auth/components/ga/activity/components/ActivityAmount';
import ActivityIcon from 'apps/auth/components/ga/activity/components/ActivityIcon';
import ActivityStatus from 'apps/auth/components/ga/activity/components/ActivityStatus';
import ActivityTitle from 'apps/auth/components/ga/activity/components/ActivityTitle';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { AUTH_PAYMENTS_HISTORY } from 'apps/auth/constants/UrlConstants';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { getGaActivityDate } from 'apps/auth/helpers/utils';
import { useApp, useLanguage } from 'apps/auth/hooks/selectors';

const ActivityExchangeDetails = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();

    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    const getStatusText = () => {
        let statusText;
        if (item.mobileInfo.stsId < STATUS_OK) {
            statusText = props.chequeStatusInProgress;
        } else if (item.mobileInfo.stsId > STATUS_OK && (item.cancellingProcess || item.errorCode === 69)) {
            statusText = props.chequeStatusCanceled;
        } else if (item.mobileInfo.stsId > STATUS_OK) {
            statusText = props.chequeStatusError;
        }
        if (statusText) {
            return statusText;
        }
    };

    return (
        <>
            <Row indent="adaptive-16-24">
                <ActivityIcon item={item} options={props.options} />
            </Row>
            <ActivityTitle message={mobileInfo.title} color={textColor} />
            <Row indent={mobileInfo.stsId !== STATUS_OK && !item.payComment ? 'adaptive-24-32' : null}>
                <ActivityAmount item={item} options={props.options} useArrow />
                <ActivityAmount item={item} options={props.options} baseColor="primary" isFrom={false} />
                {item.payComment && (
                    <Text variant="paragraph" ellipsis color="secondary">
                        {item.payComment}
                    </Text>
                )}
            </Row>
            <Row indent={mobileInfo.errorMessage ? 'adaptive-16-24' : null}>
                <ActivityStatus status={mobileInfo.stsId} comment={item.payComment} text={getStatusText()} />
            </Row>
            {mobileInfo.errorMessage && <div>{mobileInfo.errorMessage}</div>}
            {mobileInfo.stsId < STATUS_OK && item.fromBankAccountStatusBean && (
                <>
                    <Separator marginBottom="16px" />
                    <Panel
                        isHoverable
                        type="reactLink"
                        to={`${AUTH_PAYMENTS_HISTORY}?paymentId=${item.paymentId}`}
                        id={`pay_info_${item.paymentId}`}
                        negativeMargin
                    >
                        <DiskBadgeWrapper>
                            <DiskBadge variant="primary" iconName="retry" />
                        </DiskBadgeWrapper>
                        <Text color="primary">{props.payBankTransferButton}</Text>
                    </Panel>
                </>
            )}
            <Separator marginTop="48px" marginBottom={mobileInfo.stsId < STATUS_OK && item.fromBankAccountStatusBean ? '16px' : '48px'} />
            <TableContainer>
                <TableRow title={props.chequeDate} textColor={textColor} titleColor={titleColor}>
                    {getGaActivityDate(item.payTs, props.lang)}
                </TableRow>
                <TableRow title={props.chequeFee} textColor={textColor} titleColor={titleColor}>
                    {getLocalizedRawAmount(lang, country, mobileInfo.feeUp)} {mobileInfo.frCurIso}
                </TableRow>
                {mobileInfo.curRate && (
                    <TableRow title={props.chequeFxRate} textColor={textColor} titleColor={titleColor}>
                        {`${getLocalizedRawAmount(lang, country, 1)} ${mobileInfo.frCurIso} = ${getLocalizedRawAmount(lang, country, mobileInfo.curRate, 4)} ${mobileInfo.toCurIso}`}
                    </TableRow>
                )}
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    chequeStatusInProgress: state.messages.pageMessages.chequeStatusInProgress,
    chequeStatusCanceled: state.messages.pageMessages.chequeStatusCanceled,
    chequeStatusError: state.messages.pageMessages.chequeStatusError,
    chequeDate: state.messages.pageMessages.chequeDate,
    chequeFee: state.messages.pageMessages.chequeFee,
    chequeFxRate: state.messages.pageMessages.chequeFxRate,
    lang: state.language.lang,
});

export default connect(mapStateToProps)(ActivityExchangeDetails);
